var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultLayout',{attrs:{"pageProps":{
    title: ("Join " + _vm.invitedBy + " on Loop"),
    description:
      'You\'ve been invited to join Loop, click continue to finish your set-up.',
  }},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('RegistrationCard',{attrs:{"is-invite":true}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }